export default __webpack_public_path__ + "static/media/22.e57f492a.jpg";